<div class="container">
  <div class="error-notification">
    <h2>{{evaluateLanguageString(modalData.title)}}</h2>
    <div class="svg-container">
      <svg class="checkmark red-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
        <circle class="checkmark__circle red-checkmark__circle" cx="26" cy="26" r="25" fill="none" />
        <path class="checkmark__circle red-checkmark__check" fill="none" d="M16 16 36 36" />
        <path class="checkmark__circle red-checkmark__check" fill="none" d="M36 16 16 36" />
      </svg>
    </div>
    <div class="banner">
      <div class="ya-dialog-content">
        <p [innerHTML]="evaluateLanguageString(modalData.description)"></p>
      </div>
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <div class="ya-button-container">
            <button mat-flat-button (click)="confirmationBtn()">
              <span langkey="phErrorMessage_Button"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>